import { FC } from "react";
import cn from "classnames";
import { Icon, IconName, Panel } from "capitalrx-components-2.0/lib/general";

import { AccordionItemProps } from "../FAQSection.props";
import styles from "../FAQSection.module.scss";

const AccordionItem: FC<AccordionItemProps> = ({ title, content, isActive, setActiveFAQItem, ariaControls }: AccordionItemProps) => {
  const accordionIconClasses = cn({ "chevron-down": !isActive }, { "chevron-up": isActive });
  const accordionHeaderClasses = cn(styles["AccordionItemHeader"], { [styles["Active"]]: isActive });
  const accordionBodyClasses = cn(styles["AccordionItemBody"], { [styles["Active"]]: isActive });

  const handleHeaderClick = () => {
    setActiveFAQItem(title);
  };

  return (
    <Panel className={styles.AccordionItemWrapper} testId={title}>
      <button
        className={accordionHeaderClasses}
        onClick={handleHeaderClick}
        aria-label="toggle Frequently Asked Question dropdown"
        aria-expanded={isActive}
        aria-controls={`faq-section-${ariaControls}`}
        id={`faq-section-${ariaControls}-id`}
      >
        <div className={styles.AccordionTitle}>{title}</div>
        <Icon color={isActive ? "turquoise" : "black"} name={accordionIconClasses as IconName} size="regular" />
      </button>
      <div
        className={accordionBodyClasses}
        id={`faq-section-${ariaControls}`}
        role="region"
        aria-labelledby={`faq-section-${ariaControls}-id`}
      >
        {content}
      </div>
    </Panel>
  );
};

export default AccordionItem;
